










































































import Vue from 'vue'
import { Component, Watch, Prop, Emit } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppDialog from '@/components/AppDialog.vue'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import AppTextarea from '@/components/AppTextarea.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { Claim } from '../interfaces/claim'
import { newClaim, editClaim } from '../gql/claim.gql'

@Component({
  components: {
    AppTextField,
    AppDialog,
    AppTextarea,
    AppDatePicker
  }
})
export default class ClaimDialog extends Vue {
  @Prop({ type: Boolean }) readonly value!: boolean;
  @Prop({ type: String }) readonly title!: string;
  @Prop({ type: Boolean }) readonly disable!: boolean;
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy;
  @Prop({ type: Boolean }) readonly isEdit!: boolean;
  @Prop({ type: Object as () => Claim }) readonly claim!: Claim;

  showDialog = false;

  claimInput: {
    [key: string]: any;
  } = {
    claimDate: '',
    accountName: '',
    claimAmount: 0,
    note: ''
  };

  get confirmText () {
    return this.isEdit ? 'Update' : 'Create'
  }

  @Watch('value')
  onShowChanged (val: boolean) {
    if (val) {
      this.claimInput.accountName = this.policy.account.name
      if (this.isEdit && this.claim) {
        this.claimInput.claimDate = this.claim.claimDate
        this.claimInput.claimAmount = this.claim.totalAmount
        this.claimInput.note = this.claim.note
      }
    }
    this.showDialog = val
  }

  @Emit('post')
  onPostHandler () {
    // do nothing
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  // 创建claim
  async confirm () {
    if (this.validateForm()) {
      if (this.isEdit) {
        this.editClaimRequest()
      } else {
        this.newClaimRequest()
      }
    } else {
      return false
    }
  }

  async newClaimRequest () {
    const { claimDate, claimAmount, note } = this.claimInput
    try {
      const result = await this.$apollo.mutate({
        mutation: newClaim,
        variables: {
          input: {
            policyId: +this.policy.id,
            accountId: +this.policy.account.id,
            totalAmount: parseFloat(claimAmount),
            claimDate,
            note
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      showNotification({
        msg: 'Create Successfully!',
        type: SnackType.Success
      })
      this.resetForm()
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async editClaimRequest () {
    const { claimDate, claimAmount, note } = this.claimInput
    try {
      const result = await this.$apollo.mutate({
        mutation: editClaim,
        variables: {
          claimId: this.claim && +this.claim.id,
          input: {
            policyId: +this.policy.id,
            accountId: +this.policy.account.id,
            totalAmount: parseFloat(claimAmount),
            claimDate,
            note
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      showNotification({
        msg: 'Update Successfully',
        type: SnackType.Success
      })
      this.resetForm()
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  // 重置表单
  resetForm () {
    this.claimInput = {
      claimDate: '',
      claimAmount: 0,
      notes: ''
    }
    this.resetValidation()
    this.onPostHandler()
  }
  // 表单验证
  validateForm () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
  // 清除校验
  resetValidation () {
    (
      this.$refs.form as Vue & { resetValidation: () => void }
    ).resetValidation()
  }
}
